package com.iregained.site.components.sections.testimonials.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val VideoCardWrapperStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.boxShadow(0.px, 15.px, 35.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
            .transition(Transition.of("transform", 0.4.s), Transition.of("box-shadow", 0.4.s))
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.scale(1.02).boxShadow(0.px, 25.px, 45.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.15f))
    }
}

val TestimonialFilterButtonStyle = CssStyle {
    base {
        Modifier.padding(topBottom = 10.px, leftRight = 24.px).borderRadius(50.px)
            .border(1.px, LineStyle.Solid, Colors.LightGray).backgroundColor(Colors.White).color(Colors.DarkSlateGray)
            .fontSize(1.cssRem).fontWeight(FontWeight.SemiBold).cursor(Cursor.Pointer)
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        Modifier.border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
            .color(colorMode.toSitePalette().brand.primary)
    }
}

val TestimonialFilterButtonActiveStyle = CssStyle {
    base {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.primary)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary).color(Colors.White)
    }
    hover { Modifier.color(Colors.White) }
}

val TestimonialCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().height(100.percent).backgroundColor(Colors.White).borderRadius(16.px).padding(32.px)
            .boxShadow(0.px, 4.px, 20.px, color = Color.argb(0.05f, 0f, 0f, 0f)).display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .transition(Transition.of("transform", 250.ms), Transition.of("box-shadow", 250.ms))
    }
    hover {
        Modifier.transform { translateY((-6).px) }.boxShadow(0.px, 12.px, 30.px, color = Color.argb(0.1f, 0f, 0f, 0f))
    }
}

val TestimonialsCtaPrimaryButtonStyle = CssStyle {
    base {
        Modifier
            .width(220.px)
            .boxSizing(BoxSizing.BorderBox) // Ensures internal calculation
            .border(2.px, LineStyle.Solid, Colors.Transparent) // ADDED: Matches secondary button footprint
            .backgroundColor(Colors.White)
            .color(colorMode.toSitePalette().brand.primary)
            .boxShadow(0.px, 4.px, 15.px, color = Color.argb(0.15f, 0f, 0f, 0f))
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        Modifier
            .transform { translateY((-2).px) }
            .boxShadow(0.px, 6.px, 20.px, color = Color.argb(0.25f, 0f, 0f, 0f))
    }
}

val TestimonialsCtaSecondaryButtonStyle = CssStyle {
    base {
        Modifier
            .width(220.px)
            .boxSizing(BoxSizing.BorderBox) // Ensures internal calculation
            .border(2.px, LineStyle.Solid, Colors.White) // Existing border
            .backgroundColor(Colors.Transparent)
            .color(Colors.White)
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        Modifier
            .backgroundColor(Colors.White.copyf(alpha = 0.1f))
            .transform { translateY((-2).px) }
    }
}